<template>
  <div class="home">
    <div class="hero">
      <video class="background-video" autoplay loop muted playsinline>
        <source src="/videos/hero-background2.mp4" type="video/mp4" />
      </video>
      <div class="overlay"></div>
      <div class="hero-content">
        <h1>Krilin Schmid</h1>
        <p>Fotografie · Videografie · Webentwicklung</p>
        <div class="gallery-button">
          <a
            href="https://krilinschmid.mypixieset.com"
            target="_blank"
            class="btn square"
          >Zur Galerie</a>
          <router-link to="/about" class="btn square">Über mich</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style scoped>
.home {
  min-height: 100vh;
}

/* Hero Section */
.hero {
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: #0d0d0d;
}

.background-video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.55);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
  padding: 0 1rem;
  max-width: 90%;
}

/* Buttons quadratisch */
.btn.square {
  border-radius: 0;
  min-width: 140px;
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  color: var(--accent);
  border: 2px solid var(--accent);
  font-weight: bold;
  font-size: 1.1rem;
  text-decoration: none;
  transition: transform 0.2s ease, background 0.3s ease;
}

.btn.square:hover {
  color: #0d0d0d;
  background: #f0b66c;
}

/* Header animation */
.hero h1 {
  font-size: 7rem;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 4px;
  font-weight: 800;
  color: #e0a458;
  text-shadow: 0 4px 10px rgba(0,0,0,0.6);
  opacity: 0;
  transform: scale(0.8) translateY(40px);
  filter: blur(8px);
  animation: heroTitleIn 1.2s ease-out forwards;
  animation-delay: 0.4s;
  word-break: break-word;
}

.hero p {
  font-size: 1.8rem;
  color: #d6d1ce;
  letter-spacing: 2px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.5);
  white-space: nowrap;
  overflow: hidden;
  width: 0;
  margin: 0 auto;
  animation: typing-center 2.5s steps(60, end) forwards;
  animation-delay: 1.5s;
}

.gallery-button {
  margin-top: 2rem;
  opacity: 0;
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
  animation: fadeInButtons 1s forwards;
  animation-delay: 4s;
}

/* Keyframes */
@keyframes typing-center {
  from { width: 0; }
  to { width: 100%; }
}

@keyframes fadeInButtons {
  to { opacity: 1; }
}

@keyframes heroTitleIn {
  0% { opacity: 0; transform: scale(0.8) translateY(40px); filter: blur(8px); }
  100% { opacity: 1; transform: scale(1) translateY(0); filter: blur(0); }
}

/* Responsive */
@media only screen and (max-width: 768px) {
  .hero h1 { font-size: 3.5rem; }
  .hero p { font-size: 1.2rem; white-space: normal; }
}

@media only screen and (max-width: 480px) {
  .hero h1 { font-size: 2.5rem; }
  .hero p { font-size: 1rem; white-space: normal; }
  .gallery-button { flex-direction: column; gap: 0.8rem; }
}
</style>
